<div class="carousel-fluid">
  <div
    #list
    (wheel)="handleScroll($event)"
    [ngClass]="{
      'carousel-fluid__list': true,
      'carousel-fluid__list--center': !hasScroll
    }"
  >
    <img
      #image
      draggable="false"
      *ngFor="let imageItem of listCarousel; index as i"
      [src]="imageItem.linkHtml"
      errorImage="/assets/imgs/image-gallery-default.png"
      offset="500"
      onerror="this.src='/assets/imgs/image-gallery-default.png'"
      [id]="'carousel-fluid-image-' + i"
      [alt]="imageItem.alt"
      class="carousel-fluid__image"
      (click)="handleOpenModal(i)"
      (load)="setScroll(list)"
    />
  </div>
  <button
    *ngIf="position > 0 && hasScroll"
    class="carousel-fluid__button carousel-fluid__button--prev"
    (click)="handleNavigationButton(-1)"
  >
    <lib-icon
      class="carousel-fluid__icon carousel-fluid__icon--prev"
      icon="arrow_left"
      size="xs"
      color="#ffffff"
    ></lib-icon>
  </button>
  <button
    *ngIf="position < listCarousel.length - 1 && hasScroll"
    class="carousel-fluid__button carousel-fluid__button--next"
    (click)="handleNavigationButton(1)"
  >
    <lib-icon
      class="carousel-fluid__icon carousel-fluid__icon--next"
      icon="arrow_right"
      size="xs"
      color="#ffffff"
    ></lib-icon>
  </button>
</div>
